import * as React from "react";

/**
 * Constantes para las keys de los contextos globales
 */
export const CONTEXT_KEYS = {
	I18N: "__GRIDDO_I18N_CONTEXT__",
	MODULE_PREVIEW: "__GRIDDO_MODULE_PREVIEW_CONTEXT__",
	NAVIGATION: "__GRIDDO_NAVIGATION_CONTEXT__",
	PAGE: "__GRIDDO_PAGE_CONTEXT__",
	SESSION: "__GRIDDO_SESSION_CONTEXT__",
	SITE: "__GRIDDO_SITE_CONTEXT__",
} as const;

type GlobalContexts = Record<string, React.Context<any>>;

/**
 * Crea o reutiliza un React.Context globalmente compartido.
 * Evita crear múltiples instancias si hay múltiples versiones del paquete
 * (pensado para el split del monorepo).
 *
 * @param key Un identificador único
 * @param defaultValue Valor por defecto del contexto
 */
export function getOrCreateGlobalContext<T>(
	key: string,
	defaultValue: T,
): React.Context<T> {
	const globalObj = (
		typeof globalThis !== "undefined" ? globalThis : {}
	) as GlobalContexts;

	if (!(key in globalObj)) {
		globalObj[key] = React.createContext<T>(defaultValue);
	}

	return globalObj[key] as React.Context<T>;
}
